<!-- Navbar Start -->
<nav class="navbar navbar-expand-lg fixed-top navbar-custom sticky sticky-dark navbar-light bg-dark" id="navbar">
    <div class="container">
        <!-- LOGO -->
        <a class="navbar-brand logo" routerLink="/">
            <img src="assets/logos/aa_white.png" alt="ArgoApps" class="logo-light" height="31">
            <img src="assets/logos/aa.png" alt="ArgoApps" class="logo-dark" height="31">
        </a>
        <div class="ml-auto">
            <a routerLink="/" class="btn btn-sm btn-outline-light"><i class="mdi mdi-arrow-left mr-1"></i> Volver al Inicio</a>
        </div>
    </div>
</nav>
<!-- Navbar End -->

<!-- Hero Start -->
<section class="hero-2-bg position-relative d-flex align-items-center bg-gradient-primary py-5" id="delete-header" style="min-height: 280px; padding-top: 110px !important;">
    <div class="hero-2-bg-overlay"></div>
    <div class="container position-relative" style="z-index: 2;">
        <div class="row justify-content-center text-center">
            <div class="col-lg-10">
                <span class="badge badge-warning text-dark px-3 py-2 mb-3 font-weight-bold f-14">rentasCR App</span>
                <h1 class="text-white font-weight-normal mb-3">Solicitud de Eliminación de Datos y Cuenta <span class="text-warning font-weight-bold">rentasCR</span></h1>
                <p class="text-white-70 f-16 mb-0">Gestión de borrado de información personal y desactivación definitiva de usuario.</p>
            </div>
        </div>
    </div>
    <div class="hero-bottom-img">
        <img src="assets/images/hero-2-shape.png" alt="" class="img-fluid d-block w-100 mx-auto">
    </div>
</section>
<!-- Hero End -->

<!-- Main Content Start -->
<section class="section bg-light" id="delete-content">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                
                <!-- Stepper Progress Header -->
                <div class="card border-0 shadow-sm mb-4 rounded-lg p-3 bg-white">
                    <div class="d-flex justify-content-around text-center">
                        <div class="step-item" [ngClass]="{'text-warning font-weight-bold': step === 1, 'text-muted': step !== 1}">
                            <span class="badge badge-pill" [ngClass]="{'badge-warning text-dark': step === 1, 'badge-secondary': step !== 1}">1</span>
                            <div class="f-13 mt-1">Autenticación</div>
                        </div>
                        <div class="step-divider align-self-center border-top flex-grow-1 mx-2"></div>
                        <div class="step-item" [ngClass]="{'text-warning font-weight-bold': step === 2, 'text-muted': step !== 2}">
                            <span class="badge badge-pill" [ngClass]="{'badge-warning text-dark': step === 2, 'badge-secondary': step !== 2}">2</span>
                            <div class="f-13 mt-1">Código de Confirmación</div>
                        </div>
                        <div class="step-divider align-self-center border-top flex-grow-1 mx-2"></div>
                        <div class="step-item" [ngClass]="{'text-warning font-weight-bold': step === 3, 'text-muted': step !== 3}">
                            <span class="badge badge-pill" [ngClass]="{'badge-success': step === 3, 'badge-secondary': step !== 3}">3</span>
                            <div class="f-13 mt-1">Confirmación</div>
                        </div>
                    </div>
                </div>

                <!-- Main Wizard Card -->
                <div class="card border-0 shadow-sm p-4 p-md-5 rounded-lg bg-white">
                    
                    <!-- Alert Warning Notice (30 Days Deletion Warning) -->
                    <div class="alert alert-warning border-0 p-3 mb-4 rounded d-flex align-items-start" style="background-color: #fff3cd; border-left: 4px solid #ffc107 !important;">
                        <i class="mdi mdi-alert-circle-outline f-24 text-warning mr-3 mt-1"></i>
                        <div>
                            <h6 class="font-weight-bold text-dark mb-1">Aviso Importante sobre la Eliminación de Datos:</h6>
                            <p class="mb-0 text-dark f-14 line-height-1_5">
                                La información de tu cuenta y todos tus datos asociados se borrarán de forma permanente en los próximos <strong>30 días naturales</strong> y <strong>no podrás recuperar la información</strong> una vez procesada la solicitud.
                            </p>
                        </div>
                    </div>

                    <!-- STEP 1: Login Credentials -->
                    <div *ngIf="step === 1">
                        <h4 class="font-weight-normal text-dark mb-2">Paso 1: Inicia sesión con tu cuenta de <span class="text-warning font-weight-bold">rentasCR</span></h4>
                        <p class="text-muted f-14 mb-4">Ingresa tu correo electrónico y contraseña registrados en la aplicación rentasCR para verificar tu identidad.</p>

                        <div *ngIf="errorMessage" class="alert alert-danger p-3 mb-3 f-14">
                            <i class="mdi mdi-alert-circle mr-1"></i> {{errorMessage}}
                        </div>

                        <form (ngSubmit)="onSubmitLogin()">
                            <div class="form-group mb-3">
                                <label class="font-weight-medium text-dark f-14">Correo Electrónico</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-light border-right-0"><i class="mdi mdi-email-outline"></i></span>
                                    </div>
                                    <input type="email" class="form-control bg-light border-left-0" [(ngModel)]="email" name="email" placeholder="ejemplo@correo.com" required>
                                </div>
                            </div>

                            <div class="form-group mb-4">
                                <label class="font-weight-medium text-dark f-14">Contraseña</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-light border-right-0"><i class="mdi mdi-lock-outline"></i></span>
                                    </div>
                                    <input type="password" class="form-control bg-light border-left-0" [(ngModel)]="password" name="password" placeholder="Tu contraseña de rentasCR" required>
                                </div>
                            </div>

                            <button type="submit" class="btn btn-warning text-white btn-block py-2 font-weight-bold" [disabled]="isLoading">
                                <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                <i *ngIf="!isLoading" class="mdi mdi-arrow-right-circle mr-1"></i> Continuar y Solicitar Código
                            </button>
                        </form>
                    </div>

                    <!-- STEP 2: 6-Digit Verification Code -->
                    <div *ngIf="step === 2">
                        <h4 class="font-weight-normal text-dark mb-2">Paso 2: Código de Confirmación de 6 dígitos</h4>
                        <p class="text-muted f-14 mb-3">
                            Hemos enviado un código de verificación de 6 dígitos al correo electrónico: <strong class="text-dark">{{email}}</strong>.
                        </p>

                        <div *ngIf="errorMessage" class="alert alert-danger p-3 mb-3 f-14">
                            <i class="mdi mdi-alert-circle mr-1"></i> {{errorMessage}}
                        </div>

                        <div *ngIf="successMessage" class="alert alert-success p-3 mb-3 f-14">
                            <i class="mdi mdi-check-circle mr-1"></i> {{successMessage}}
                        </div>

                        <form (ngSubmit)="onSubmitCode()">
                            <label class="font-weight-medium text-dark f-14 mb-2">Ingresa el código de 6 dígitos:</label>
                            
                            <div class="d-flex justify-content-between mb-4 code-inputs">
                                <input *ngFor="let digit of codeDigits; let i = index" 
                                       [id]="'digit-' + i" 
                                       type="text" 
                                       inputmode="numeric"
                                       pattern="[0-9]*"
                                       maxlength="1" 
                                       class="form-control text-center font-weight-bold f-20 mx-1 border" 
                                       style="width: 48px; height: 52px; border-radius: 8px;"
                                       [value]="codeDigits[i]" 
                                       [name]="'digit' + i" 
                                       (keyup)="onKeyUp($event, i)" 
                                       (keydown)="onKeyDown($event, i)"
                                       (paste)="onPaste($event)">
                            </div>

                            <button type="submit" class="btn btn-danger btn-block py-2 font-weight-bold mb-3" [disabled]="isLoading">
                                <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                <i *ngIf="!isLoading" class="mdi mdi-delete-forever mr-1"></i> Confirmar Eliminación de Datos
                            </button>

                            <div class="text-center">
                                <button type="button" class="btn btn-link text-muted f-14" (click)="resendCode()" [disabled]="isLoading">
                                    <i class="mdi mdi-refresh mr-1"></i> Reenviar código a mi correo
                                </button>
                            </div>
                        </form>
                    </div>

                    <!-- STEP 3: Final Confirmation & Remote Logout Notice -->
                    <div *ngIf="step === 3" class="text-center py-3">
                        <div class="icon-circle bg-danger text-white mx-auto mb-4 d-flex align-items-center justify-content-center" style="width: 72px; height: 72px; border-radius: 50%;">
                            <i class="mdi mdi-delete-check f-36"></i>
                        </div>

                        <h3 class="font-weight-bold text-dark mb-3">Eliminación de Cuenta Procesada</h3>
                        
                        <div class="alert alert-success border-0 p-3 mb-4 rounded">
                            <p class="mb-0 text-success font-weight-medium f-15">
                                Se ha procesado exitosamente la eliminación para la cuenta <strong>{{email}}</strong>.
                            </p>
                        </div>

                        <div class="bg-light p-4 rounded text-left mb-4" style="border-left: 4px solid #dc3545;">
                            <h6 class="font-weight-bold text-dark mb-2"><i class="mdi mdi-check-decagram text-danger mr-1"></i> Borrado Completo y Cierre de Sesión:</h6>
                            <p class="text-muted f-15 line-height-1_6 mb-3">
                                Toda la información de tu cuenta (perfil de usuario, publicaciones de alquiler, historial de chats, fotos y alertas creadas) ha sido <strong>eliminada permanentemente</strong> de nuestra base de datos.
                            </p>
                            <p class="text-danger font-weight-bold f-14 mb-0">
                                <i class="mdi mdi-cellphone-link-off mr-1"></i> Se ha enviado una orden de <strong>cierre de sesión automático</strong> a todos los dispositivos móviles o navegadores donde tu cuenta permanecía abierta.
                            </p>
                        </div>

                        <a routerLink="/" class="btn btn-primary px-4 py-2 font-weight-bold">
                            <i class="mdi mdi-home mr-1"></i> Volver a la página principal
                        </a>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>
<!-- Main Content End -->

<!-- Footer Start -->
<app-footer></app-footer>
<!-- Footer End -->
